import React from "react";
import { Routes, Route } from "react-router-dom";
import Search from '../pages/search/search';
import About from '../pages/about';
import Privacy from '../pages/privacy';
import Services from '../pages/services';
import Home from '../pages/home';
import SignIn from '../account/signin';
import Signup from '../account/signup';
import Account from '../account/account';
import SignOut from '../account/signout';
import Schedule from '../pages/schedule';
import MessageBox from '../pages/message';

import AddService from "../pages/addService";
import { AdminDashboard, EditServices, AdminUsers } from '../pages/adminDashboard';
import AdminAccountSearch from "../pages/admin-account-search";
import ManageUser from "../pages/ManageUser";
import RegisterUser from "../pages/RegisterUser";
import ManageServices from '../pages/manageServices';
import Login from "../account/Login";
import BookingPage from '../pages/booking/BookingPage';
import Terms from '../account/tabs/Terms';
// Main acts as a container for the routing
const Main = () => {
    return (
        <main>
            <div className='Main'>
                <Routes>
                    <Route exact path='/' element={<Home />} />
                    <Route exact path='/home' element={<Home />} />
                    <Route exact path='/search' element={<Search />} />
                    <Route exact path='/services' element={<Services />} />
                    {/* <Route exact path='/about' element={<About />} /> */}
                    <Route exact path='/schedule' element={<Schedule />} />
                    <Route exact path='/privacy' element={<Privacy />} />
                    <Route exact path='/login' element={<Login />} />
                    <Route exact path='/signin' element={<Login />} />
                    <Route exact path='/signup' element={<Signup />} />
                    <Route exact path='/account' element={<Account />} />
                    <Route exact path='/signout' element={<SignOut />} />
                    <Route exact path='/messages' element={<MessageBox />} />
                    <Route exact path='/addService' element={<AddService />} />
                    <Route exact path='/admin' element={<AdminDashboard />} />
                    <Route exact path='/editServices' element={<EditServices />} />
                    <Route exact path='/adminUsers' element={<AdminUsers />} />
                    <Route exact path='/admin-account-search' element={<AdminAccountSearch />} />
                    <Route exact path='/manage-user' element={<ManageUser />} />
                    <Route exact path='/register' element={<RegisterUser />} />
                    <Route path="/manage-user/:userId" element={<ManageUser />} />
                    <Route path="/book/:healerId" element={<BookingPage />} />
                    <Route path = "/terms" element = {<Terms/>}></Route>
                </Routes>
            </div>

        </main>
    );
};

export default Main;
